export const DangerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.17998 3.52978L1.44742 14.7693C1.30861 15.0097 1.23516 15.2822 1.23438 15.5598C1.2336 15.8374 1.30552 16.1103 1.44299 16.3515C1.58045 16.5926 1.77866 16.7936 2.0179 16.9344C2.25714 17.0752 2.52908 17.1508 2.80665 17.1539H16.2718C16.5493 17.1508 16.8213 17.0752 17.0605 16.9344C17.2998 16.7936 17.498 16.5926 17.6354 16.3515C17.7729 16.1103 17.8448 15.8374 17.844 15.5598C17.8433 15.2822 17.7698 15.0097 17.631 14.7693L10.8984 3.52978C10.7567 3.29618 10.5572 3.10303 10.3191 2.96899C10.0811 2.83495 9.81244 2.76453 9.53921 2.76453C9.26599 2.76453 8.99737 2.83495 8.75929 2.96899C8.5212 3.10303 8.32168 3.29618 8.17998 3.52978V3.52978Z"
      stroke=""
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.53906 7.61536V10.7948" stroke="" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.53906 13.9744H9.54701" stroke="" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
